var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 4H3.33333H14",
    stroke: "#D41414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.33398 3.99967V2.66634C5.33398 2.31272 5.47446 1.97358 5.72451 1.72353C5.97456 1.47348 6.3137 1.33301 6.66732 1.33301H9.33398C9.68761 1.33301 10.0267 1.47348 10.2768 1.72353C10.5268 1.97358 10.6673 2.31272 10.6673 2.66634V3.99967M12.6673 3.99967V13.333C12.6673 13.6866 12.5268 14.0258 12.2768 14.2758C12.0267 14.5259 11.6876 14.6663 11.334 14.6663H4.66732C4.3137 14.6663 3.97456 14.5259 3.72451 14.2758C3.47446 14.0258 3.33398 13.6866 3.33398 13.333V3.99967H12.6673Z",
    stroke: "#D41414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTrash);
export default __webpack_public_path__ + "static/media/fi_trash.c44d98d3654b725ccfd13b03c336ae8a.svg";
export { ForwardRef as ReactComponent };